import Swiper from 'swiper/bundle';
import $ from 'jquery';

export default function tariffSwiper() {
    let swiperTariff = null;
    let isSwiping = false;
    function initSwiperTariff() {
        swiperTariff = new Swiper(".avu-swiper-tariff", {
                    slidesPerView: 'auto',
                    centeredSlides: true,
                    spaceBetween: 30,
                    rewind: true,
                    pagination: {
                        el: ".swiper-pagination-tariff",
                        clickable: true,
                    },
                    navigation: {
                        nextEl: ".swiper-button-next-tariff",
                        prevEl: ".swiper-button-prev-tariff",
                    },
                    a11y: {
                        enabled: false,
                    },
                    on: {
                        touchStart: () => {
                            isSwiping = true;
                        },
                        touchEnd: () => {
                            isSwiping = false;
                        },
                        click: (swiper, event) => {
                            if (isSwiping) {
                                event.preventDefault();
                            }
                        },
                    }
                });
    }
    let swiperTariffPlus = null;
    function initSwiperTariffPlus() {
        swiperTariffPlus = new Swiper(".avu-swiper-tariff-plus", {
                    slidesPerView: 'auto',
                    centeredSlides: true,
                    spaceBetween: 30,
                    rewind: true,
                    pagination: {
                        el: ".swiper-pagination-tariff-plus",
                        clickable: true,
                    },
                    navigation: {
                        nextEl: ".swiper-button-next-tariff-plus",
                        prevEl: ".swiper-button-prev-tariff-plus",
                    },
                    a11y: {
                        enabled: false,
                    },
                });
    }
    // Swiper plugin initialization
    if ($('.avu-swiper-tariff').length > 0) {
        initSwiperTariff();
    }
    if ($('.avu-swiper-tariff-plus').length > 0) {
        initSwiperTariffPlus();
    }
    // Swiper plugin initialization on window resize
    //The function has been removed to ensure that the swiper does
    // not start from the first slide when using vertical scroll.
    /*$(window).on('resize', function () {
            if ($('.avu-swiper-tariff').length > 0) {
                initSwiperTariff();
            }
            if ($('.avu-swiper-tariff-plus').length > 0) {
                initSwiperTariffPlus();
            }
        });*/
    $('.swiper-slide-content .avu-find-tariff').click(function() {
        let navigationHeight = 420;
        let zoomLevel = window.devicePixelRatio * 100;
        if(zoomLevel >= 99) {
            navigationHeight = 420;
        }
        if(zoomLevel >= 89 && zoomLevel < 99) {
            navigationHeight = 520;
        }
        if(zoomLevel >= 79 && zoomLevel < 89) {
            navigationHeight = 600;
        }
        if(zoomLevel >= 67 && zoomLevel < 79) {
            navigationHeight = 700;
        }
        if(zoomLevel >= 50 && zoomLevel < 67) {
            navigationHeight = 1000;
        }
        let elementOffset = $('#avu-calculator').offset().top;
        let elementHeight = $('#avu-calculator').outerHeight();
        let windowHeight = $(window).height();
        let scrollToPosition = 0;
        if(window.innerWidth > 992) {
            scrollToPosition = elementOffset - navigationHeight + (windowHeight - elementHeight) / 2;
        } else {
            scrollToPosition = elementOffset - 250 + (windowHeight - elementHeight) / 2;
        }
        $('html').animate({
            scrollTop: scrollToPosition
        }, 0, function() {
            $('#avu-calculator').css({
                'transition': 'transform 2s',
                'transform': 'scale(1.2)'
            });

            setTimeout(function() {
                $('#avu-calculator').css({
                    'transform': 'scale(1)'
                });
            }, 1000);
        });
    });
}

//Scroll to calcultor from buttons
$(document).ready(function() {
    $('button, a').on('click', function(event) {
        let href = $(this).attr('href');
        if (href) {
            let currentOrigin = window.location.origin;
            let currentPath = window.location.pathname + window.location.search;
            let targetUrl = new URL(href, currentOrigin);

            if (targetUrl.hash === '#avu-calculator' && targetUrl.origin === currentOrigin && targetUrl.pathname === currentPath) {
                event.preventDefault();
                scrollToAndZoom();
            } else if (targetUrl.hash === '#avu-calculator') {
                event.preventDefault();
                window.location.href = targetUrl.href;
            }
        }
    });
    if (window.location.hash === '#avu-calculator') {
        setTimeout(scrollToAndZoom, 100);
        history.replaceState(null, null, window.location.pathname + window.location.search);
    }
    function scrollToAndZoom() {
        let navigationHeight = 480;
        let zoomLevel = window.devicePixelRatio * 100;
        if (zoomLevel >= 99) {
            navigationHeight = 480;
        }
        if (zoomLevel >= 89 && zoomLevel < 99) {
            navigationHeight = 520;
        }
        if (zoomLevel >= 79 && zoomLevel < 89) {
            navigationHeight = 600;
        }
        if (zoomLevel >= 67 && zoomLevel < 79) {
            navigationHeight = 700;
        }
        if (zoomLevel >= 50 && zoomLevel < 67) {
            navigationHeight = 1000;
        }
        let elementOffset = $('#avu-calculator').offset().top;
        let elementHeight = $('#avu-calculator').outerHeight();
        let windowHeight = $(window).height();
        let scrollToPosition = 0;
        if (window.innerWidth > 992) {
            scrollToPosition = elementOffset - navigationHeight + (windowHeight - elementHeight) / 2;
        } else {
            scrollToPosition = elementOffset - 250 + (windowHeight - elementHeight) / 2;
        }
        $('html').animate({
            scrollTop: scrollToPosition
        }, 0, function() {
            $('#avu-calculator').css({
                'transition': 'transform 2s',
                'transform': 'scale(1.2)'
            });
            setTimeout(function() {
                $('#avu-calculator').css({
                    'transform': 'scale(1)'
                });
            }, 1000);
        });
    }
});



